<template id="sort-by">
    <div class="dropdown-container" v-bind:class="{ 'is-active': isDropdownActive }">
        <div class="dropdown-trigger">
            <button class="dropbtn" v-on:click.prevent="isDropdownActive = !isDropdownActive">
                <span>{{ titleText.toUpperCase() }}</span>
                <span class="icon d-none d-md-inline">
                    <img v-if="!isDropdownActive" class="lazyload" data-src="https://objects.kaxmedia.com/auto/o/139757/00c0516d11.svg" width="12" height="12" alt="Red Down Arrow">
                    <img v-else class="lazyload" data-src="https://objects.kaxmedia.com/auto/o/139760/8a16b5d70f.svg" width="12" height="12" alt="Red Down Arrow">
                </span>
            </button>
        </div>
        <div
            v-if="isDropdownActive"
            id="sort-dropdown-menu"
            class="sort-dropdown-menu"
            v-bind:class="{ 'is-active': isDropdownActive }"
        >
            <div class="d-md-none d-flex justify-content-between bg-white mobile-header">
                <div>
                    {{ titleText }}
                </div>
                <div class="close-div"
                   v-on:click.prevent="isDropdownActive = !isDropdownActive"
                >
                    {{ closeLabelText }}
                    <svg class="ml-1 closeTooltip" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="24" height="24" preserveAspectRatio="xMidYMid meet" viewBox="0 0 50 50"><path d="M37.304 11.282l1.414 1.414l-26.022 26.02l-1.414-1.413z" fill="#d23b42"/><path d="M12.696 11.282l26.022 26.02l-1.414 1.415l-26.022-26.02z" fill="#d23b42"/></svg>
                </div>
            </div>
            <div class="sort-dropdown-content" v-bind:class="{ 'is-active': isDropdownActive }">
                <div class="clear-text-desktop text-right" v-show="sortBy.length > 0">
                    <button class="btn sort-clearall-btn" @click="clearSorting()">
                        <span>{{ clearLabelText }}</span>
                    </button>
                    <hr />
                </div>
                <li v-for="(filter, index) in sortOptionsData" :key="index">
                    <label class="checkbox-radio-wrapper">
                        <input
                            :id="index"
                            :name="filter.name"
                            :value="filter.value"
                            type="radio"
                            :checked="filter.checked"
                            @change="updateCheckedValue"
                        />
                        <span>
                            <span class="inner-circle"></span>
                        </span>
                        <label :for="index">{{ filter.locaclisedLabel }}</label>
                    </label>
                    <hr v-if="index !== sortOptions.length - 1" />
                </li>
                <div class="py-3 py-md-0 d-flex justify-content-center">
                    <button
                        class="closebtn d-block d-md-none d-lg-none d-xl-none py-2"
                        @click="clearSorting()"
                    >
                        {{ clearLabelText.toUpperCase() }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        sortOptions: {
            type: Array,
            required: false,
            default() {
                return [
                    {
                        value: 'a-z',
                        name: 'sort',
                        label: 'A - Z',
                        locaclisedLabel: 'A - Z',
                        checked: false,
                    },
                    {
                        value: 'z-a',
                        name: 'sort',
                        label: 'Z - A',
                        locaclisedLabel: 'Z - A',
                        checked: false,
                    },
                    {
                        value: 'new-old',
                        name: 'sort',
                        label: 'Newest - Oldest',
                        locaclisedLabel: 'Newest - Oldest',
                        checked: false,
                    },
                    {
                        value: 'old-new',
                        name: 'sort',
                        label: 'Oldest - Newest',
                        locaclisedLabel: 'Oldest - Newest',
                        checked: false,
                    },
                    {
                        value: 'highest-rtp',
                        name: 'sort',
                        label: 'Highest RTP - Lowest RTP',
                        locaclisedLabel: 'Highest RTP - Lowest RTP',
                        checked: false,
                    },
                    {
                        value: 'lowest-rtp',
                        name: 'sort',
                        label: 'Lowest RTP - Highest RTP',
                        locaclisedLabel: 'Lowest RTP - Highest RTP',
                        checked: false,
                    },
                ];
            },
        },
    },
    data() {
        return {
            isDropdownActive: false,
            sortOptionsData: this.sortOptions,
            sortBy: [],
        };
    },
    computed: {
        clearLabelText() {
            return window.translations.sortBy.clear_label || 'CLEAR ALL';
        },
        titleText() {
            return window.translations.sortBy.title || 'SORT';
        },
        closeLabelText() {
            return window.translations.sortBy.close_label || 'Close';
        },
    },
    methods: {
        updateCheckedValue(event) {
            let index = event.currentTarget.getAttribute('id');
            let className = this.sortOptionsData[index].name;
            let newValue = !this.sortOptionsData[index].checked;

            this.sortOptionsData.filter(function (item) {
                if (item.name == className) {
                    item.checked = false;
                }
            });

            this.sortOptionsData[index].checked = newValue;
            this.emitSelectedValues();
        },
        emitSelectedValues() {
            this.sortBy = this.sortOptionsData
                .filter(function (item) {
                    if (item.checked) {
                        return item;
                    }
                })
                .map((filteredObj) => filteredObj.value);

            this.$emit('sort-by-items', this.sortBy);
        },
        close(e) {
            if (!this.$el.contains(e.target)) {
                this.isDropdownActive = false;
            }
        },
        clearSorting() {
            this.sortOptionsData.filter(function (item) {
                item.checked = false;
            });

            this.emitSelectedValues();
        },
    },
    mounted() {
        document.addEventListener('click', this.close);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.close);
    },
};
</script>